import { commonTranslationJA } from '@common/translations/ja';
import { newPedigreeJA } from '../components/new-pedigree/translations/ja';
import { pedigreeImportJA } from '../components/pedigree-import/translations/ja';

export const pedigreesJA = {
  ...newPedigreeJA,
  ...pedigreeImportJA,
  ...commonTranslationJA,
  Pedigrees: 'Pedigrees',
  'Are you sure that you would like to delete the folder named': 'Are you sure that you would like to delete the folder named',
  'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain': 'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain',
  Folder: 'Folder',
  'items in': 'items in',
  'There no pedigrees to display': 'There no pedigrees to display',
  'Folder Name': 'Folder Name',
  'New Folder': 'New Folder',
  'Move':'Move',
  'Failed to move folder': 'Failed to move folder',
  'Select where to move the folder to': 'Select where to move the folder to',
  'Move Folder':'Move Folder',
  'Rename Folder':'Rename Folder',
  'Open Individual Spreadsheet for Folder':'Open Individual Spreadsheet for Folder',
  'Open Pedigree Spreadsheet for Folder':'Open Pedigree Spreadsheet for Folder',
  'Delete Folder':'Delete Folder',
  'Import pedigree' : 'Import pedigree',
  'Read Folder': 'Read Folder',
  'Add Ped': 'Add Ped',
  'Del Ped': 'Del Ped',
  'Modify Ped': 'Modify Ped',
  'Ped Read': 'Ped Read',
  'Ped Write': 'Ped Write',
  'Failed to save Folder': 'Failed to save Folder',
  'Failed to get Folder Security Settings': 'Failed to get Folder Security Settings',
  'Only Probands': 'Only Probands',
  'Individual Datasheet': 'Individual Datasheet',
  'Pedigree Datasheet': 'Pedigree Datasheet',
  'Icon Subtext': 'Icon Subtext',
  'Icon Symbols': 'Icon Symbols',
  'Pedigree Added' : 'Pedigree Added' ,
  'SmartDraw Dimensions': 'SmartDraw Dimensions',
  'Pedigree Properties': 'Pedigree Properties',
  'Pedigree Fields' : 'Pedigree Fields' ,
  'Smart Header': 'Smart Header',
  'Smart Footer': 'Smart Footer',
  'Formats': 'Formats',
  'Template Options': 'Template Options',
  'Template Formats': 'Template Formats',
  'OK': 'OK',
  'Are you sure that you would like to delete the folder named': 'Are you sure that you would like to delete the folder named',
  'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain': 'Deleting this folder will delete all of the pedigrees and individuals in this folder as well as any sub-folders and items they contain',
  'Failed to get create formats folder': 'Failed to get create formats folder',
  'Failed to get delete formats folder': 'Failed to get delete formats folder',
  'Failed to get delete formats': 'Failed to get delete formats',
  'Failed to delete folder': 'Failed to delete folder',
  'Failed to rename folder': 'Failed to rename folder',
  'Edit Folder Settings': 'Edit Folder Settings',
  'Failed to get Format folders': 'Failed to get Format',
  'Failed to get Folder formats': 'Failed to get Folder formats',
  'Failed to get Folder Security Settings': 'Failed to get Folder Security Settings',
  'Override Pedigree Level Security': 'Override Pedigree Level Security',
  'Class Name': 'Class Name',
  'Invites': 'Invites',
  'Individuals': 'Individuals',
  'Actions': 'Actions',
  'Open Pedigree': 'Open Pedigree',
  'Copy Pedigree': "Copy Pedigree",
  'Move Pedigree': 'Move Pedigree',
  'Rename Pedigree': 'Rename Pedigree',
  'Delete Pedigree': 'Delete Pedigree',
  'Open Pedigree Datasheet': 'Open Pedigree Datasheet',
  'Create Shortcut': 'Create Shortcut',
  'Export Pedigree': 'Export Pedigree',
  'Export Pedigrees': 'Export Pedigrees',
  'Edit Pedigree Security': 'Edit Pedigree Security',
  'Generate External Link': 'Generate External Link',
  'Failed to get data': 'Failed to get data',
  'Failed to save columns': 'Failed to save columns',
  'There no individuals to display': 'There no individuals to display',
  'Rename Individual': 'Rename Individual',
  'Open Individual Datasheet': 'Open Individual Datasheet',
  'Open Pedigree': 'Open Pedigree',
  'Open Test Results': 'Open Test Results',
  'New Invite': 'New Invite',
  'Launch New Questionnaire': 'Launch New Questionnaire',
  'Open Questionnaire': 'Open Questionnaire',
  'Generate Letter': 'Generate Letter',
  'Change Gender': 'Change Gender',
  'New Invite': 'New Invite',
  'Open Questionnaire': 'Open Questionnaire',
  'Send Reminder': 'Send Reminder',
  'Update Status': 'Update Status',
  'Unlock Invite': 'Unlock Invite',
  'Lock Invite': 'Lock Invite',
  'After locking this invite the patient will not be able to edit the questionnaire': 'After locking this invite the patient will not be able to edit the questionnaire',
  'Are you sure you want to lock this invite? You can unlock it again later if needed': 'Are you sure you want to lock this invite? You can unlock it again later if needed',
  'If you unlock this invite the patient will be able to access the questionnaire and modify data': 'If you unlock this invite the patient will be able to access the questionnaire and modify data',
  'Are you sure you want to unlock?': 'Are you sure you want to unlock?',
  'Failed to save lock/unlock invite': 'Failed to save lock/unlock invite',
  'View Invite History': 'View Invite History',
  'Open Pedigree': 'Open Pedigree',
  'Open Datasheet': 'Open Datasheet',
  'Generate Letter': 'Generate Letter',
  'There no invites to display': 'There no invites to display',
  'Profile Name': 'Profile Name',
  'Set as Default for All Users': 'Set as Default for All Users',
  'Set as Default for Specific Profiles': 'Set as Default for Specific Profiles',
  'Apply Current Columns Now to All Users': 'Apply Current Columns Now to All Users',
  'Apply Current Columns Now to Specific Profiles': 'Apply Current Columns Now to Specific Profiles',
  'Restore Columns to Default': 'Restore Columns to Default',
  'Failed to select profile': 'Failed to select profile',
  'Select Profile': 'Select Profile',
  'Failed to get folders': 'Failed to get folders',
  'Copy Pedigree': 'Copy Pedigree',
  Copy: 'Copy',
  'Pedigree Name': 'Pedigree Name',
  'Pedigree successfully copied': 'Pedigree successfully copied',
  'Pedigree successfully moved': 'Pedigree successfully moved',
  'Shortcut created successfully': 'Shortcut created successfully',
  'Open on Save': 'Open on Save',
  'Shortcut Name': 'Shortcut Name',
  Save: 'Save',
  'Rename Individual Names': 'Rename Individual Names',
  'Rename': 'Rename',
  'Type new pedigree name': 'Type new pedigree name',
  'Pedigree renamed successfully': 'Pedigree renamed successfully',
  'Are you sure you wish to delete the selected pedigree?': 'Are you sure you wish to delete the selected pedigree?',
  'Failed to delete pedigree': 'Failed to delete pedigree',
  'Failed to get individuals columns': 'Failed to get individuals columns',
  'Failed to get invites columns': 'Failed to get invites columns',
  'Failed to get individuals': 'Failed to get individuals',
  'Failed to get invites': 'Failed to get invites',
  'Failed to get pedigrees': 'Failed to get pedigrees',
  'Import': 'Import',
  'Cancel': 'Cancel',
  'Pedigree is imported successfully': 'Pedigree is imported successfully',
  'Upload': 'Upload',
  'File uploaded successfully': 'File uploaded successfully',
  'Upload': 'Upload',
  'File uploaded successfully': 'File uploaded successfully',
  'Pedigree Data Folders': 'Pedigree Data Folders',
  'Individual Data Folders': 'Individual Data Folders',
  'Failed to get filters': 'Failed to get filters',
  'Individual successfully renamed': 'Individual successfully renamed',
  'Failed to apply current columns to all users': 'Failed to apply current columns to all users',
  'Failed to update current columns': 'Failed to update current columns',
  'Failed to restore column to default': 'Failed to restore column to default',
  'Failed to get admin functions': 'Failed to get admin functions',
  'Failed to export Pedigree': 'Failed to export Pedigree',
  'Failed to copy pedigree': 'Failed to copy pedigree',
  'Failed to create shortcut': 'Failed to create shortcut',
  'Failed to move pedigree': 'Failed to move pedigree',
  'Are you sure you wish to delete the selected pedigrees?': 'Are you sure you wish to delete the selected pedigrees?',
  'Pedigrees successfully moved': 'Pedigrees successfully moved',
  'Move Pedigrees': 'Move Pedigrees',
  'Delete Pedigrees': 'Delete Pedigrees',
  'items found': 'items found',
  'Batch Letters': 'Batch Letters',
  'Failed to open questionnaire': 'Failed to open questionnaire',
  'The Questionnaire invitation emails were successfully submitted': 'The Questionnaire invitation emails were successfully submitted',
  'patient': 'patient',
  'Completed Manually': 'Completed Manually',
  'Inactive': 'Inactive',
  'Reviewed': 'Reviewed',
  'Failed to get status data': 'Failed to get status data',
  'Failed to update status': 'Failed to update status',
  'The Questionnaire reminder email was successfully sent': 'The Questionnaire reminder email was successfully sent',
  'Failed to update reviewed status actions' : 'Failed to update reviewed status actions',
  'Failed to change gender identity': 'Failed to change gender identity',
  'Man': 'Man',
  'Woman': 'Woman',
  'Unknown': 'Unknown',
  'Transgender man': 'Transgender man',
  'Transgender woman': 'Transgender woman',
  'Non-binary': 'Non-binary',
  'Self-described': 'Self-described',
  'Batch Letters': 'Batch Letters',
  'New Invites': 'New Invites',
  'Send Reminders': 'Send Reminders',
  'Unlock Invites': 'Unlock Invites',
  'Lock Invites': 'Lock Invites',
  'unlockInvitesMsg': 'If you unlock the invites the patients will be able to access the questionnaire and modify data. Are you sure you want to unlock?',
  'lockInvitesMsg': 'After locking the invites the patients will not be able to edit the questionnaire. Are you sure you want to lock the invites? You can unlock it again later if needed.',
  'invitesAreLockedToSendReminder': 'Some invite(s) are locked, unable to send reminders. Please unlock before attempting to send another reminders.',
  'inviteIsLockedToSendReminder': 'This invite is locked, unable to send reminder. Please unlock before attempting to send another reminder.',
  'The Questionnaire reminder emails were successfully sent': 'The Questionnaire reminder emails were successfully sent',
  'Failed to check questionnaires': 'Failed to check questionnaires',
  'differentQuestionnairesError': 'You can only send reminders for one questionnaire at a time. Please limit your selection to people who have been sent the same questionnaire.',
  'There is a problem with the email addresses for the selected invites': 'There is a problem with the email addresses for the selected invites',
  'Please enter valid email addresses and resend the invitations': 'Please enter valid email addresses and resend the invitations',
  'Invitations were not sent to the following individuals': 'Invitations were not sent to the following individuals',
  'individualMovePedigreeMsg': 'The individual you selected must be moved to a new pedigree in order to send a Family History Questionnaire.',
};